<template>
  <div class="deliveryRecord p-4 space-y-4">
    <viewTitle
      title="业务管理 / 预约记录管理 / 预约提货记录"
      :showReturn="true"
    >
      <template slot="return">
        <el-button
          v-has="['c-booking-pickup-export']"
          @click="onExport"
          size="small"
          type="primary"
        >导出
        </el-button>
      </template>
    </viewTitle>
    <el-radio-group @change="onSearch" v-model="queryParam.state" size="small">
      <el-radio-button
        v-for="item in stateList"
        :key="item.value"
        :label="item.value"
        >{{ item.label }}（{{
          countMap[`state_${item.value}`] || 0
        }}）</el-radio-button
      >
      <el-radio-button label
        >全部({{ countMap[`total`] || 0 }})</el-radio-button
      >
    </el-radio-group>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item>
        <el-input
          clearable
          v-model="queryParam.keyword"
          placeholder="搜索订单号、客户名称"
          class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="预约业务名称">
        <el-select
          clearable
          v-model="queryParam.business_id"
          placeholder="请选择"
        >
          <el-option
            v-for="item in business"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车辆业务类型">
        <el-select
          clearable
          v-model="queryParam.car_business_id"
          placeholder="请选择"
        >
          <el-option
            v-for="item in car_business"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车辆类型">
        <el-select
          class="w-60"
          clearable
          v-model="queryParam.vehicle_type"
          placeholder="请选择车辆类型"
        >
          <el-option
            v-for="car in vehicleTypes"
            :key="car.id"
            :label="car.name"
            :value="car.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物料类型">
        <el-input
          clearable
          v-model="queryParam.chip_type"
          placeholder="请输入物料类型"
          class="w-48"
        ></el-input>
      </el-form-item>
      <el-form-item label="车牌号">
        <el-input
          clearable
          v-model="queryParam.license_plate"
          placeholder="请输入车牌号"
          class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="申请时间">
        <el-date-picker
          class="!w-96"
          style="margin-bottom: 10px;"
          v-model="timeRange"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="timestamp"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="预约时间">
        <el-date-picker
          class="!w-96"
          style="margin-bottom: 10px;"
          v-model="queryParam.booking_day"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="yyyyMMdd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshData" size="small">刷新数据</el-button>
        <el-button @click="onReset" size="small">重置</el-button>
      </el-form-item>
    </el-form>
    <c-table
      class="mt-4"
      :isIndex="false"
      :isSelection="false"
      :selection.sync="rowKeySelection"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      row-key="booking_id"
      @loadPage="loadData"
    >
      <template slot="business_list" slot-scope="{ row }">
        <div v-for="item in row.business_list" :key="item.id">
          {{ item.name }}
        </div>
      </template>
      <template slot="name" slot-scope="{row}">
        <div>{{ row.name }}</div>
        <div>({{ row.contact }})</div>
      </template>
      <template slot="create_time" slot-scope="{ row }">{{
        row.create_time | timeFormat
      }}</template>
      <template slot="action" slot-scope="{ row }">
        <div class="space-x-2">
          <c-link
            v-if="row.booking_state == 41"
            @click="onAuth(row)"
            type="primary"
            v-has="['c-booking-pickup-auth']"
            label="授权"
          ></c-link>
          <c-link
            v-if="row.booking_state == 42"
            @click="onCalling(row)"
            type="primary"
            v-has="['c-booking-pickup-calling']"
            label="叫号"
          ></c-link>
          <c-link v-has="['c-booking-pickup-detail']" @click="onView(row)" type="primary" label="查看"></c-link>
          <c-link
            v-if="row.booking_state == 43 && needSendCard(row)"
            @click="onSendCard(row)"
            type="primary"
            v-has="['c-booking-pickup-send']"
            label="发卡"
          ></c-link>
          <c-link
            v-if="row.booking_state == 46 && needReturnCard(row)"
            @click="onReturnCard(row)"
            type="primary"
            v-has="['c-booking-pickup-return']"
            label="退卡"
          ></c-link>
        </div>
      </template>
    </c-table>
    <outward ref="outward" @ok="refreshData" />
    <editWarehouse ref="editWarehouse" @ok="refreshData" />
    <AccessCardModal :showDoor="true" ref="accessCard" @ok="refreshData"/>
  </div>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import outward from "./components/outward.vue";
import editWarehouse from "./components/editWarehouse.vue";
import AccessCardModal from '../AccessCard/components/AccessCardModal.vue'
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      countMap: {},
      queryParam: {
        state: "",
        keyword: "",
        business_id: "",
        car_business_id: "",
        vehicle_type: "",
        chip_type: "",
        license_plate: "",
        booking_day: ""
      },
      columns: [
        { width: 150, label: "预约号", prop: "code" },
        // 提货记录按当前业务口径展示客户字段，避免与送货记录的供应商口径混淆。
        { label: "客户名称", prop: "supplier_name" },
        { label: "客户编号", prop: "supplier_code" },
        { label: "车辆业务类型", prop: "business_list" },
        // { label: "订单号", prop: "order_code" },
        {  width: 160, label: "申请时间", prop: "create_time" },
        { label: "车牌号", prop: "license_plate" },
        { label: "司机", prop: "name" },
        {
          label: "预约状态",
          prop: "booking_state",
          formatData: row => {
            return this.businessState[row.booking_state] || "--";
          }
        },
        {
          label: "预约日期",
          prop: "booking_day",
          formatData: row => {
            return row.booking_day
              ? moment(row.booking_day, "YYYYMMDD").format("YYYY-MM-DD")
              : "--";
          }
        },
        {
          label: "预约时间段",
          prop: "booking_time",
          formatData: row => {
            return `${row.begin_time} ~ ${row.end_time}`;
          }
        },
        { label: "操作", prop: "action" }
      ],
      stateList: [
        { label: "待登记", value: "1" },
        { label: "待授权", value: "41" },
        { label: "待叫号", value: "42" },
        { label: "待进厂", value: "43" },
        { label: "待入厂磅", value: "48" },
        { label: "待测水", value: "49" },
        { label: "待出厂", value: "46" },
        { label: "已完成", value: "8" },
        { label: "已过号", value: "47" },
        { label: "已关闭", value: "7" }
      ],
      business: [],
      // 显式维护提货业务类型常量，避免查询条件误加载送货业务。
      pickupBusinessType: 12,
      allCarBusiness: [],
      car_business: [],
      // 关闭 mixin 默认首屏加载，改由页面在初始化完成后显式触发一次查询。
      disabledCreated: true,
      // 关闭查询条件修改后的自动查询，避免慢查询在输入和筛选过程中被频繁触发。
      autoSearch: false,
      loadCallBack: this.getCount,
      // 导出沿用预约记录导出接口，并明确按提货业务口径传参与当前筛选条件保持一致。
      exportDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/export_booking_record1",
          data: this.buildBookingRecordRequestData(params),
          noLoading: true
        });
      },
      // 列表查询与导出复用同一套参数组装逻辑，避免页面与导出口径不一致。
      fetchDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/query_booking_record1",
          data: this.buildBookingRecordRequestData(params)
        });
      }
    };
  },
  computed: {
    ...mapGetters(["businessState", "vehicleTypes"])
  },
  watch: {
    // 监听预约业务变化，联动车辆业务类型下拉选项，避免出现无效筛选组合。
    'queryParam.business_id': {
      handler() {
        this.syncCarBusinessOptionsByBusiness();
      }
    }
  },
  components: {
    outward,
    editWarehouse,
    AccessCardModal
  },
  mixins: [initListMinxin, mixinTableLyout],
  methods: {
    // 提货记录按门岗模式切换卡动作，未配置时维持历史行为。
    needSendCard(row) {
      const passMode = Number(row.in_pass_mode || 0);
      if (passMode === 2) {
        return true;
      }
      if (passMode === 1) {
        return false;
      }
      return true;
    },
    // 提货记录按出门门岗模式切换退卡动作，未配置时维持历史行为。
    needReturnCard(row) {
      const passMode = Number(row.out_pass_mode || 0);
      if (passMode === 2) {
        return true;
      }
      if (passMode === 1) {
        return false;
      }
      return true;
    },
    // 返回提货记录页默认查询条件，便于初始化与重置复用同一套口径。
    getDefaultQueryParam() {
      return {
        state: "",
        keyword: "",
        business_id: "",
        car_business_id: "",
        vehicle_type: "",
        chip_type: "",
        license_plate: "",
        booking_day: ""
      };
    },
    // 统一组装提货记录查询与导出的请求参数，确保申请时间和预约时间筛选口径一致。
    buildBookingRecordRequestData(params) {
      const { booking_day, begin_time, end_time, ...data } = params;
      const hasTimeRange = Array.isArray(this.timeRange) && this.timeRange.length === 2;

      // 关键步骤：提货页的申请时间选择器绑定在 timeRange，需要在这里显式转换成接口所需的秒级时间戳。
      const createBeginTime = begin_time || (hasTimeRange ? Math.floor(this.timeRange[0] / 1000) : "");
      const createEndTime = end_time || (hasTimeRange ? Math.floor(this.timeRange[1] / 1000) : "");

      return {
        ...data,
        business_type: this.pickupBusinessType,
        create_begin_time: createBeginTime,
        create_end_time: createEndTime,
        booking_day_begin_time: booking_day ? booking_day[0] : "",
        booking_day_end_time: booking_day ? booking_day[1] : ""
      };
    },
    // 根据预约业务同步车辆业务类型选项，避免出现无效筛选组合。
    syncCarBusinessOptionsByBusiness() {
      if (!this.allCarBusiness.length) {
        return;
      }

      const businessId = this.queryParam.business_id;
      const nextOptions = businessId
        ? this.allCarBusiness.filter(item => item.pid === businessId)
        : [...this.allCarBusiness];

      this.car_business = nextOptions;

      if (
        this.queryParam.car_business_id &&
        !nextOptions.some(item => item.id === this.queryParam.car_business_id)
      ) {
        this.queryParam.car_business_id = "";
      }
    },
    // 从路由参数初始化查询条件，并在业务数据加载后复用同一套联动逻辑。
    initQueryParamFromRoute() {
      const { query } = this.$route;
      Object.keys(query).forEach(key => {
        if (this.queryParam.hasOwnProperty(key)) {
          this.$set(this.queryParam, key, query[key]);
        }
      });
    },
    // 加载提货预约业务与提货车辆业务类型数据，并缓存全量子业务用于前端联动。
    async getBusiness() {
      const [businessResponse, carBusinessResponse] = await Promise.all([
        this.$common.http({
          url: "/api/queue/admin/query_business",
          data: {
            // 关键步骤：预约提货记录页只展示提货业务，避免把送货业务一起带入查询条件。
            state: 0,
            keyword: "",
            type: this.pickupBusinessType,
            is_parent: 0,
            page_size: 999
          }
        }),
        this.$common.http({
          url: "/api/queue/admin/query_business",
          data: {
            // 关键步骤：车辆业务类型同样按提货业务口径过滤，保持父子下拉口径一致。
            state: 0,
            keyword: "",
            type: this.pickupBusinessType,
            is_parent: 1,
            page_size: 999
          }
        })
      ]);

      // 先缓存提货子业务全集，再复用既有联动逻辑按父业务过滤展示项。
      this.business = businessResponse.data.data.data;
      this.allCarBusiness = carBusinessResponse.data.data.data;
      this.syncCarBusinessOptionsByBusiness();
    },
    // 获取提货记录各状态统计，用于页面页签数量展示。
    getCount() {
      this.$common
        .http({
          url: "/api/queue/admin/count_booking_record1",
          data: {
            business_type: this.pickupBusinessType
          },
          noLoading: true
        })
        .then(res => {
          const total = Object.values(res.data.data).reduce((a, b) => a + b);
          this.countMap = { ...res.data.data, total: total };
        });
    },
    // 重置查询条件并恢复提货业务类型的完整可选项。
    onReset() {
      this.pagintion.page = 1;
      this.timeRange = [];
      this.queryParam = this.getDefaultQueryParam();
      this.syncCarBusinessOptionsByBusiness();
      this.onSearch();
    },
    // 跳转提货记录详情页查看当前预约单。
    onView(row) {
      this.$router.push({
        path: `/rhqy/service/AppointPickup/Detail/${row.booking_info_id}`
      });
    },
    // 授权
    onAuth(row) {
      this.$confirm("确认业务授权吗？", "授权确认").then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/auth_booking",
            data: {
              booking_ids: row.booking_id
            }
          });
          this.refreshData();
        } catch (error) {}
      });
    },
    // 叫号
    onCalling(row) {
      this.$confirm("确认业务确认叫号吗？", "叫号确认").then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/special_call_booking",
            data: {
              booking_ids: row.booking_id
            }
          });
          this.refreshData();
        } catch (error) {}
      });
    },
    // 发卡
    onSendCard(row) {
      this.$refs.accessCard.onOpen(row.booking_id, 1);
    },
    // 退卡
    onReturnCard(row) {
      this.$refs.accessCard.onOpen(row.booking_id, 2);
    }
  },
  created() {
    // 先回填路由查询条件，再在业务数据加载完成后同步联动子业务选项。
    this.queryParam = this.getDefaultQueryParam();
    this.initQueryParamFromRoute();
    this.getBusiness();

    // 关键步骤：页面首次进入时仍需主动查询一次，但后续修改筛选条件不再自动触发查询。
    this.$nextTick(() => {
      this.refreshData();
    });
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/common";
</style>
